const utils = {
    getEdgeBasePath() {
        const productionEdge = (typeof localStorage === 'undefined') ? process.env.EDGE_URL : '/edge';
        const basePath = (process.env.NODE_ENV === 'production') ? productionEdge : 'http://localhost:3010';
        return basePath;
    },
};

export default utils;